import { api } from "_shared/_stores/api";
import { permissionCacheTags } from "permissions/_api/permission-cache-tags";
import { z } from "zod";

/**
 * How many proposals and work agreements a person's grants on those records open, from
 * `GET /work/reach/{userId}`: the count behind a Need-to-know row's "covers … : 4 proposals now"
 * on the person page (#6831). The server counts what the by-id reads would admit them to, so the
 * page never counts records itself.
 */

export const WorkRecordReachZ = z.object({
  userId: z.string(),
  proposals: z.number().int().nonnegative(),
  workAgreements: z.number().int().nonnegative(),
});

export type WorkRecordReach = z.infer<typeof WorkRecordReachZ>;

export const workRecordReachApi = api.injectEndpoints({
  endpoints: (build) => ({
    getWorkRecordReach: build.query<WorkRecordReach, string>({
      query: (userId) => ({ url: `work/reach/${userId}`, method: "GET" }),
      transformResponse: (response: unknown) => WorkRecordReachZ.parse(response),
      // A grant changed on the page changes what the person is on, so it is read again with the lists;
      // and a grant of theirs changed elsewhere does too, by the permissions realtime event (#6785).
      providesTags: (_result, _error, userId) => [{ type: "Permission" as const, id: "LIST" }, permissionCacheTags.grantee(userId)],
    }),
  }),
});

export const { useGetWorkRecordReachQuery } = workRecordReachApi;
